import { createHeadCells } from 'src/Utils';
export var WIDTHS = ['20%', '20%', '20%', '20%', '20%'];
export var handleCells = function () {
    return createHeadCells('Fecha', 'Tipo', 'Recurrente', 'Entidad', 'Nombre Espacio');
};
